export const initialState = {
  isEnrollLoading: false,
  data: null,
  error: null,
  qrExpired: false,
}
